module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Plan of the Collected Works")]), _vm._v(" "), _c('p', {
    staticClass: "serau",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Edited by Bruce Caldwell")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-bottom": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume I")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("The Fatal Conceit: The Errors of Socialism (1988)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume II")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("The Road to Serfdom: Text and Documents—The Definitive Edition (2007)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume III")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("The Trend of Economic Thinking: Essays on Political Economists and Economic History (1991)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume IV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("The Fortunes of Liberalism: Essays on Austrian Economics and the Ideal of Freedom (1992)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume V")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Good Money, Part I: The New World (1999)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume VI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Good Money, Part II: The Standard (1999)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume VII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Business Cycles, Part I (2012)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume VIII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Business Cycles, Part II (2012)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume IX")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Contra Keynes and Cambridge: Essays, Correspondence (1995)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume X")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Socialism and War: Essays, Documents, Reviews (1997)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Capital and Interest (2015)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("The Pure Theory of Capital (2007)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XIII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Studies on the Abuse and Decline of Reason: Text and Documents (2010)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XIV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("The Sensory Order and Other Writings on the Foundations of Theoretical Psychology (2017)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("The Market and Other Orders (2014)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XVI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Hayek on Mill: The Mill-Taylor Friendship and Related Writings (2015)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XVII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("The Constitution of Liberty: The Definitive Edition (2011)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XVIII")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Essays on Liberalism and the Economy (2021)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Volume XIX")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Law, Legislation, and Liberty (2021)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Supplement")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Hayek on Hayek: An Autobiographical Dialogue (1994)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "serpf"
  }, [_vm._v("The plan is provisional. Minor alterations may occur in titles of individual books, and several additional volumes may be added.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a0acca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-hayek-vol19-0003.vue
// module id = 60
// module chunks = 0